import { Col, Container, Row } from "react-bootstrap";
import styled from "styled-components";
import { comparisonData } from "../../data";
import secureIcon from "../../dist/images/secure.svg";
import optimalIcon from "../../dist/images/diamond.svg";

const PlanComparison = () => {
  return (
    <ComparisonWrapper className="p-4 p-lg-5 bg-white rounded-4 bg-white">
      <Container fluid>
        <div>
          <Title className="text-light-black">Quick Plan Comparison</Title>
          <Row className="mb-0 border-bottom mx-1 pb-2">
            <Col xs={12} md={4}></Col>
            <Col xs={6} md={4} className="d-none d-md-block">
              <PlanHeader>
                <img src={secureIcon} alt="secure" className="width-50" />
                <PlanName>Secure Plan</PlanName>
              </PlanHeader>
            </Col>
            <Col xs={6} md={4} className="d-none d-md-block">
              <PlanHeader>
                <img src={optimalIcon} alt="optimal" className="width-50" />
                <PlanName>Optimal Plan</PlanName>
              </PlanHeader>
            </Col>
          </Row>
          {comparisonData.map((item) => (
            <ComparisonRow key={item.id}>
              <FeatureLabel xs={12} md={4}>
                {item.feature}
              </FeatureLabel>
              <PlanValue xs={12} md={4}>
                <MobileLabel>
                  <img src={secureIcon} alt="secure" className="width-30 mr-2" />
                  Secure:
                </MobileLabel>
                {item.securePlan}
              </PlanValue>
              <PlanValue xs={12} md={4}>
                <MobileLabel>
                  <img src={optimalIcon} alt="optimal" className="width-30 mr-2" />
                  Optimal:
                </MobileLabel>
                {item.optimalPlan}
              </PlanValue>
            </ComparisonRow>
          ))}
        </div>
      </Container>
    </ComparisonWrapper>
  );
};

export default PlanComparison;

const ComparisonWrapper = styled.div`
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #7fb5fcff;
`;

const Title = styled.h2`
  font-size: 36px;
  font-weight: 500;
  margin-bottom: 50px;

  @media (max-width: 768px) {
    font-size: 28px;
    margin-bottom: 35px;
  }

  @media (max-width: 576px) {
    font-size: 24px;
    margin-bottom: 30px;
  }
`;

const PlanHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const PlanName = styled.h3`
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  color: #10b981;

  @media (max-width: 858px) {
    font-size: 20px;
  }

  @media (max-width: 576px) {
    font-size: 18px;
  }
`;

const ComparisonRow = styled(Row)`
  border-bottom: 1px solid #e0e0e0;
  padding: 22px 0;
  margin: 0;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 576px) {
    padding: 18px 0;
  }
`;

const FeatureLabel = styled(Col)`
  font-size: 18px;
  font-weight: 400;
  color: #2d2d2d;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 12px;
  }

  @media (max-width: 576px) {
    font-size: 15px;
  }
`;

const PlanValue = styled(Col)`
  font-size: 18px;
  font-weight: 400;
  color: #2d2d2d;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    font-size: 16px;
    text-align: left;
    justify-content: flex-start;
    padding-left: 20px;
  }

  @media (max-width: 576px) {
    font-size: 15px;
    padding-left: 15px;
  }
`;

const MobileLabel = styled.span`
  display: none;
  font-weight: 600;
  margin-right: 8px;
  color: #666;

  @media (max-width: 768px) {
    display: inline;
  }
`;
